import MuiAccordionActions from '@mui/material/AccordionActions'
import { FC } from 'react'

import { AccordionActionsProps } from './accordion-actions.types'

export const AccordionActions: FC<AccordionActionsProps> = ({ children, ...props }) => {
  return <MuiAccordionActions {...props}>{children}</MuiAccordionActions>
}
